export const AppSetting =  {

    db: {
        isDbEnabled: true,
        version:1,
        name:'WiseLife'
    }

}
